import type { Exercise, UserProfile } from '../../db/types';

// Mechanical labels are prompts to review known restrictions, not medical clearance.
const axialIds = [7, 10, 14, 16, 17, 18, 21, 22, 23, 27];
const id = (n: number) => `10000000-0000-0000-0000-${String(n).padStart(12, '0')}`;
export const axialExerciseIds = new Set(axialIds.map(id));
export function exerciseWarning(exercise: Exercise, profile: UserProfile | null): string | null {
  if (!profile) return null;
  if (profile.excludedExerciseIds.includes(exercise.id)) return 'Вы исключили это упражнение в своём профиле.';
  if (profile.avoidAxialLoad && axialExerciseIds.has(exercise.id)) return 'У упражнения есть осевая нагрузка. Вы указали ограничение: избегать осевой нагрузки.';
  if (profile.avoidAxialLoad && exercise.isCustom) return 'Нагрузка этого пользовательского упражнения не классифицирована. Сверьтесь со своими ограничениями.';
  return null;
}

export const starterTemplates = [
  { key: 'full-body-a' as const, name: 'Full body · A', exercises: [19, 2, 9, 20, 24, 31] },
  { key: 'full-body-b' as const, name: 'Full body · B', exercises: [20, 3, 12, 19, 26, 28] }
].map(template => ({ ...template, exercises: template.exercises.map((n, i) => ({
  exerciseId: id(n), targetSets: 2, targetRepsMin: 8, targetRepsMax: 12,
  targetWeightKg: null, notes: null,
  priority: (i < 3 ? 'core' : i < 5 ? 'additional' : 'optional') as 'core' | 'additional' | 'optional'
})) }));
